import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './filters/filters.js'
import { store } from './store/store.js'
import Notifications from 'vue-notification'
import VueGoodTablePlugin from 'vue-good-table';
import vbclass from 'vue-body-class'
import VTooltip from 'v-tooltip'
import vSelect from 'vue-select'
import VeeValidate from 'vee-validate'
import VueMeta from 'vue-meta'
import VModal from 'vue-js-modal'
import VueSmoothScroll from 'vue2-smooth-scroll'
import VueGtag from "vue-gtag";
import VueMoment from 'vue-moment'


Vue.use(VueGtag, {
  config: { id: "UA-166064709-1" }
}, router);

Vue.use(VeeValidate, { classes: true });
Vue.use(vbclass, router);
Vue.use(Notifications);
Vue.use(VTooltip);
Vue.use(VueSmoothScroll, { updateHistory: false })
Vue.use(VueGoodTablePlugin);
Vue.use(VueMeta);
Vue.use(VModal, { scrollable: true } );
Vue.use(VueMoment);

import './assets/css/stylesheet.css'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-select/dist/vue-select.css';
import 'flag-icon-css/css/flag-icon.min.css';

import GlobalHeader from '@/components/GlobalHeader.vue'
import GlobalFooter from '@/components/GlobalFooter.vue'
import GlobalNavigation from '@/components/GlobalNavigation.vue'
import i18n from './i18n'
import AgencyApi from "@/services/agencyApi";
import {auth} from '@/firebaseConfig';

Vue.component('GlobalHeader', GlobalHeader);
Vue.component('GlobalFooter', GlobalFooter);
Vue.component('GlobalNavigation', GlobalNavigation);
Vue.component('v-select', vSelect)


Vue.config.productionTip = false;

auth.onAuthStateChanged(async () => {
  let api = new AgencyApi();
  if (!window.TravelPlatform.agency && !window.TravelPlatform.site) {
    let siteData = (await api.getSiteData(window.TravelPlatform.key)).data;
    window.TravelPlatform.agency = siteData.agency;
    window.TravelPlatform.site = siteData.site;
    let siteId = siteData.agency.websiteHostName.replace(/\./gi, "").toLowerCase();
    document.cookie = `x-siteId=${siteId};path=/`;

    i18n.locale = siteData.site.display.language;
  }
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');

});

